import React from "react";
import { TailSpin } from "react-loading-icons";

export default function LoadingIcon() {
  return <div className="App-loading-icon">
    <TailSpin stroke="#1e2744" width="15%" height="15%"/>
  </div>;
}
